Vue.component('slidemodal', {
    props: {
        
        contentid: {
            type: String,            
        },
        id: {
            type: String
        },
        title: {
            type: String
        }
    },
    data () {
        return {
        
        }
    },
    created () {
        let self = this;

        document.addEventListener('keyup', function (evt) {
            if (evt.key === 'Escape') {
                self.close();
            }
        });
    },
    
    mounted () {
        this.swapContent();
        if (this.$el.attributes.autoopen) {
            this.open();
        }
    },
    methods: {
        swapContent () {
            if (this.contentid != 'none') {
                let swap = document.getElementById(this.contentid);
                let content = swap.innerHTML;
                this.$refs.modalcontent.innerHTML = content;
                swap.remove();
            }
            
        },
        open () {
            let t = document.getElementById(this.id);
            t.classList.add("active")
        },
        close () {
            let t = document.getElementById(this.id);
            t.classList.remove("active")
        }
    }

});